import { render } from "./BoxFilter.vue?vue&type=template&id=1678d7a9&scoped=true&ts=true"
import script from "./BoxFilter.vue?vue&type=script&lang=ts"
export * from "./BoxFilter.vue?vue&type=script&lang=ts"

import "./BoxFilter.vue?vue&type=style&index=0&id=1678d7a9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1678d7a9"]])

export default __exports__